<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13SR6Q5/tc-custom/9781609458010.jpg?1728726151383" alt="This image is the cover for the book Slowworm's Song"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Slowworm's Song
      </h1>
      <p class="bookDescription body article font2">
        <p>A Best Book Of 2022 (New Yorker) A Best Book Of Fall 2022 (Wall Street Journal)  From Costa Award-winning and Booker Prize-shortlisted author Andrew Miller comes a tender tale of guilt, trust, and a father's yearning to atone.   A harmless-looking letter drops onto the doormat in Stephen Rose's Somerset home like an unexploded bomb. It is a summons to an inquiry in Belfast, asking him to give testimony about his participation in a disastrous event during the Troubles–one he has long worked to forget.  An ailing ex-soldier and recovering alcoholic, Stephen has just begun to build a fragile bond with Maggie, the adult daughter he barely knows. For two years, he has worked hard to earn her trust, but the tragedy of what occurred back in the summer of 1982 has the power to destroy their new relationship. To buy time, he decides to write her an account of his life. Part explanation, part confession, it is also a love letter to Maggie.   When the moment comes that he must face what happened in Belfast that summer, the consequences are devastating––but ultimately liberating. Giving voice to those little heard in the literature of the Irish Troubles, The Slowworm’s Song is an unforgettable story about a man who learns that the only way back from the underworld is up.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Miller
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4193f580